import type { ExtractPropTypes, PropType } from '@vue/composition-api'

// 禁止访问 | 申诉提交成功 | 解封失败
export type forbidPageStatusType = 'forbid' | 'commit' | 'fail' | 'shareForbid'

const props = {
  status: {
    type: String as PropType<forbidPageStatusType>,
    default: 'forbid'
  },
  groupId: {
    type: [Number, String]
  },
  fileId: {
    type: [Number, String]
  },
  sId: {
    type: [Number, String]
  },
  isMobile: {
    type: Boolean,
    default: false
  }
}

export type forbidPagePropsType = ExtractPropTypes<typeof props>

export default props
